import { createSlice, PayloadAction } from "@reduxjs/toolkit";
type DailyData = { name: string; value: number };
type VehicleData = { name: string; value: number };
interface DashboardState {
  dailyData: DailyData[];
  vehicleData: VehicleData[];
  loading: boolean;
  error: string | null;
}
const initialState: DashboardState = {
  dailyData: [],
  vehicleData: [],
  loading: false,
  error: null,
};
interface DashboardPayload {
  dailyData: DailyData[];
  vehicleData: VehicleData[];
}
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess: (state, action: PayloadAction<DashboardPayload>) => {
      state.dailyData = action.payload.dailyData;
      state.vehicleData = action.payload.vehicleData;
      state.loading = false;
    },
    fetchDashboardFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const {
  fetchDashboardRequest,
  fetchDashboardSuccess,
  fetchDashboardFailure,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
